<template>

    <div class="delaypicker">
        <v-input :size="size" :model="val" placeholder="0" @input="val = $event" />
        <v-select class="increment ml-5" :size="size" :model="increment" @input="increment = $event">
            <option value="m">Minutes</option>
            <option value="h">Hours</option>
            <option value="d">Days</option>
            <option value="w">Weeks</option>
        </v-select>
    </div>

</template>

<style scoped lang="scss">

    .delaypicker {
        @include font-medium(12px);
        display: flex;
        input {
            flex-shrink: 0;
            flex-grow: 0;
            width: 95px;
        }
        .increment {
            flex-grow: 1;
            width: 130px;
        }
    }

</style>

<script>

import numeral from 'numeral';

export default {

    props: {
        model: {
            required: true,
        },
        size: {
            type: String,
            default: 'md',
        },
        defaultIncrement: {
            type: String,
            default: 'd',
        },
    },

    data() {
        return {
            increment: this.defaultIncrement,
            val: null,
        }
    },

    mounted() {
        let val = this.model;
        if (val === '' || val === null || val === undefined) {
            return;
        };
        // Set increment.
        if (val < 60 * 60 * 2) {
            // Show minutes if under 2 hours.
            this.increment = 'm'
        } else if (val < 60 * 60 * 24 * 2) {
            // Show hours if under 2 days.
            this.increment = 'h';
        } else if (val < 60 * 60 * 24 * 7 * 8) {
            // Show days if under 8 weeks.
            this.increment = 'd';
        } else {
            this.increment = 'w';
        }
        // Set value in the form of increment.
        if (this.increment === 'm') {
            val = val / 60;
        } else if (this.increment === 'h') {
            val = val / 60 / 60;
        } else if (this.increment === 'd') {
            val = val / 60 / 60 / 24;
        } else if (this.increment === 'w') {
            val = val / 60 / 60 / 24 / 7;
        }
        this.val = numeral(val).format('0.[0]');
    },

    watch: {

        increment() {
            this.toSeconds(this.val);
        },

        val(val) {
            this.toSeconds(val);
        },

    },

    methods: {

        toSeconds(val) {
            if (val === '' || val === null || val === undefined) {
                this.$emit('input', null);
            } else if (this.increment === 'm') {
                this.$emit('input', val * 60);
            } else if (this.increment === 'h') {
                this.$emit('input', val * 60 * 60);
            } else if (this.increment === 'd') {
                this.$emit('input', val * 60 * 60 * 24);
            } else if (this.increment === 'w') {
                this.$emit('input', val * 60 * 60 * 24 * 7);
            }
        },

    },

}

</script>
